import { Iprops } from "../UploadPartsList/uploadpartslistinterface";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import helperfunctions from "../../../utils/helperfunctions";
import partsService from "../../../services/partsservice";
import "./uploadpartlist.scss";
import { DataTable } from '../../CommonComponent';
import { Error } from "@progress/kendo-react-labels";
import { NumericTextBox, TextBox } from '@progress/kendo-react-inputs';
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { confirmDailog } from "../../ConfirmDailog";
import { Upload, UploadFileInfo } from "@progress/kendo-react-upload";
import { UPLOADFILETYPE } from "../../../const/enum";
import Loader from "../../Loader";
import {
    LocalizationProvider,
    loadMessages,
  } from "@progress/kendo-react-intl";

function UploadPartsList(props: Iprops) {
    const [invalidFile, setInvalidFile] = useState<any>([]);
    const [invalidFileResponse, setInvalidFileResponse] = useState<any>([]);
    const { headercurrentuser, globalData } = props;
    const requestIntervalRef = React.useRef<any>({});
    const progressRef = React.useRef<any>({});
    const [files, setFiles] = useState<any>([]);
    const [filteredFiles, setFilteredFiles] = useState<any>([]);
    const { t } = useTranslation();
    const { manufactureOption } = props;
    const downloadTemplate = () => {
        fetch('/webapp/DownloadUrl')
            .then(async (response) => await response.json())
            .then((data: any) => {
                window.open(data.url, '_self');
            })
    }
    const [isSaveError, setIsSaveError] = useState<boolean>(false);
    const [ispartsinfo, setispartsinfo] = useState(false);
    const [partData, setPartData] = useState<any[]>([]);
    const [partDataSource, setPartDataSource] = useState<any[]>([]);
    const [updatePartDataSource, setUpdatePartDataSource] = useState<boolean>(true);
    const [isAddingParts, setIsAddingParts] = useState(false)
    const uploadRef = React.createRef<any>();
    const partsinfoOnclick = () => {
        setispartsinfo(!ispartsinfo);
    };
    
    useEffect(() => {
        if (updatePartDataSource)
            setPartDataSource([...partData]);
    }, [partData])

    const Action = (item: any) => {
        const dataItem = item.row.dataItem;
        const inEdit = item.row.dataItem.inEdit;
        return (
            <td>
                <div>
                    <span>
                        {inEdit ? <button className='editdeletebtn mr-2' onClick={() => update(dataItem)} title={t(RESOURCE.MyK_Label_ShoppingCart_Update)}><span className='fa fa-check mr-1'></span>{t(RESOURCE.MyK_Label_ShoppingCart_Update)}</button> :
                            <button className='editdeletebtn mr-2' onClick={() => edit(dataItem)} title={t(RESOURCE.MyK_Label_Edit)}><span className='fa fa-pencil mr-1'></span>{t(RESOURCE.MyK_Label_Edit)}</button>
                        }
                    </span>
                    <span>
                        {inEdit ?
                            <button className='editdeletebtn' onClick={() => cancel(dataItem)} title={t(RESOURCE.MyK_Label_Cancel)}><span className='fa fa-ban mr-1'></span>{t(RESOURCE.MyK_Label_Cancel)}</button> :
                            <button className='editdeletebtn' onClick={() => remove(dataItem)} title={t(RESOURCE.MyK_Label_Delete)}><span className='fa fa-trash mr-1'></span>{t(RESOURCE.MyK_Label_Delete)}</button>
                        }
                    </span>
                </div>
            </td>
        )
    }

    useEffect(() => {
        const messages = helperfunctions.uploadResources(t);
        messages["upload"]["uploadSelectedFiles"] = t(RESOURCE.MyK_Label_SC_Up_Upload_File);
        loadMessages(messages, "myUploadCustomMessages");
    }, [])

    const quantityCell = React.useMemo(() => (props: any) => <QuantityCellRender {...props} />, [])
    const manufactuerCell = React.useMemo(() => (props: any) => <ManufactureCellRender {...props} isSaveError={isSaveError} />, [isSaveError])
    const partNumberCell = React.useMemo(() => (props: any) => <PartNumberCellRender {...props} isSaveError={isSaveError} />, [isSaveError])

    const QuantityCellRender = (props: any) => {
        const [isError, setIsError] = useState<boolean>(false);
        const [errorMessage, setErrorMessage] = useState<any>(null);
        const handleOnChange = (e: any) => {
            setUpdatePartDataSource(false);
            props.onChange({
                dataItem: props.dataItem,
                field: props.field,
                syntheticEvent: e.syntheticEvent,
                value: e.value
            });

            if (!helperfunctions.minMaxValidation(e.value, 1, 9999)) {
                setIsError(true);
                setErrorMessage(t(RESOURCE.MyK_Grid_Validation_Msg_MR_Quantity));
            }
            else {
                setIsError(false);
                setErrorMessage(null);
            }
        };
        return (
            <td>
                {props.dataItem.inEdit ? (
                    <>
                        <NumericTextBox
                            value={props.dataItem[props.field]}
                            onChange={handleOnChange}
                            min={1}
                            max={9999}
                            defaultValue={1}
                        />
                        {isError && <Error> {String(errorMessage)}</Error>}
                    </>
                ) : props.dataItem[props.field]}
            </td>
        );
    };

    const ManufactureCellRender = (props: any) => {
        const isRequiredError = props.isSaveError && !helperfunctions.requiredValidation(props.dataItem[props.field]);
        const [isError, setIsError] = useState<boolean>(isRequiredError);
        const [errorMessage, setErrorMessage] = useState<any>(isRequiredError ? t(RESOURCE.MyK_Grid_Validation_Msg_Required) : null);
        const handleOnChange = (e: any) => {
            props.onChange({
                dataItem: props.dataItem,
                field: props.field,
                syntheticEvent: e.syntheticEvent,
                value: e.value.title
            });

            if (!helperfunctions.requiredValidation(e.value)) {
                setIsError(true);
                setErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Manufacture_Required));
            }
            else {
                setIsError(false);
                setErrorMessage(null);
            }

        };
        const value = manufactureOption?.find((s: any) => s.title == props.dataItem[props.field]);
        return (
            <td>
                {props.dataItem.inEdit ? (
                    <>
                        <DropDownList
                            data={manufactureOption}
                            textField="title"
                            dataItemKey="value"
                            value={value}
                            defaultValue={value}
                            onChange={handleOnChange}
                        ></DropDownList>

                        {isError && <Error> {String(errorMessage)}</Error>}
                    </>
                ) : (props.dataItem[props.field])}
            </td>
        );
    };

    const PartNumberCellRender = (props: any) => {
        const isRequiredError = props.isSaveError && !helperfunctions.requiredValidation(props.dataItem[props.field]);
        const [isError, setIsError] = useState<boolean>(isRequiredError);
        const [errorMessage, setErrorMessage] = useState<any>(isRequiredError ? t(RESOURCE.MyK_Grid_Validation_Msg_Required) : null);
        const handleOnChange = (e: any) => {
            props.onChange({
                dataItem: props.dataItem,
                field: props.field,
                syntheticEvent: e.syntheticEvent,
                value: e.value
            });

            if (!helperfunctions.requiredValidation(e.value)) {
                setIsError(true);
                setErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Part_Number_Required));
            }
            else if (!helperfunctions.lengthValidation(e.value, 50)) {
                setIsError(true);
                setErrorMessage(t(RESOURCE.MyK_Grid_Validation_Msg_MR_MaximumLength_50));
            }
            else {
                setIsError(false);
                setErrorMessage(null);
            }
        };
        return (
            <td>
                {props.dataItem.inEdit ? (
                    <>
                        <TextBox
                            value={props.dataItem[props.field]}
                            onChange={handleOnChange}
                            maxLength={50}
                            required
                        />
                        {isError && <Error> {String(errorMessage)}</Error>}
                    </>
                ) : (props.dataItem[props.field])}
            </td>
        );
    };

    const validateData = (dataItem: any) => {
        if (helperfunctions.requiredValidation(dataItem.manufacturer) &&
            helperfunctions.requiredValidation(dataItem.qty) &&
            helperfunctions.requiredValidation(dataItem.partNumber) &&
            helperfunctions.lengthValidation(dataItem.partNumber, 50) &&
            helperfunctions.minMaxValidation(dataItem.qty, 1, 9999)
        ) {
            return true;
        }

        return false;
    }

    const onItemChange = (event: any) => {
        const field = event.field || "";
        const newData = partData.map((item: any) =>
            item.id === event.dataItem.id
                ? {
                    ...item,
                    [field]: event.value,
                }
                : item
        );
        setPartData(newData);
    };

    const remove = (dataItem: any) => {
        const confimObject = {
            title: t(RESOURCE.MyK_Label_SC_Quote_Confirmation),
            message: t(RESOURCE.Myk_Label_PartsUploadDeleteConfirmation),
            confirmmessage: '',
            buttonLabel: {
                yes: t(RESOURCE.MyK_Label_Yes),
                no: t(RESOURCE.MyK_Label_No),
            },
            yesOnclick: () => {
                const newData = partData?.filter((item: any) =>
                    item.id != dataItem.id
                ) ?? [];
                setPartData(newData);
            },
            noOnclick: () => {
            },
        }
        confirmDailog(confimObject);


    }

    const edit = (dataItem: any) => {
        setIsSaveError(false);
        let newData = partData?.map((item: any) =>
            item.id === dataItem.id
                ? { ...item, inEdit: true } :
                { ...item, inEdit: false })

        setPartData(newData);
    }

    const update = (dataItem: any) => {
        if (validateData(dataItem)) {
            setIsSaveError(false);
            let newData = partData?.map((item: any) =>
                item.id === dataItem.id
                    ? { ...item, inEdit: false, partNumber: dataItem.partNumber, qty: dataItem.qty, manufacturer: dataItem.manufacturer } :
                    { ...item })
            setUpdatePartDataSource(true);
            setPartData(newData);
        }
        else {
            setIsSaveError(true);
        }
    };

    const cancel = (dataItem: any) => {
        setIsSaveError(false);
        setUpdatePartDataSource(true);
        const originalItem = partDataSource?.find(
            (p: any) => p.id === dataItem.id
        );

        const newData = partData?.map((item: any) =>
            item.id === originalItem.id ? { ...originalItem, inEdit: false } : item
        );
        setPartData(newData);
    };

    const clearAll = () => {
        if (partData?.length > 0) {
            const confimObject = {
                title: t(RESOURCE.MyK_Label_SC_Quote_Confirmation),
                message: t(RESOURCE.MyK_Label_SC_Clear_Msg),
                confirmmessage: '',
                buttonLabel: {
                    yes: t(RESOURCE.MyK_Label_Yes),
                    no: t(RESOURCE.MyK_Label_No),
                },
                yesOnclick: () => {
                    uploadRef?.current?.onClear();
                    setPartData([]);
                    setPartDataSource([]);
                    setFilteredFiles([]);
                    setInvalidFile([]);
                    setInvalidFileResponse([]);
                    setFiles([]);
                },
                noOnclick: () => {
                },
            }
            confirmDailog(confimObject);
        }
    }

    const addPartNumber = (parts: any) => {
        setIsAddingParts(true)
        const model = {
            cart: {
                PunchoutOrderRequestId: globalData?.punchOutRequestPartLogId ?? 0,
                userAadId: headercurrentuser?.azureADId,
                distributorCode: globalData.DistributorCode,
                branchCode: globalData.BranchCode,
                customerId: globalData.CustomerId ? parseInt(globalData.CustomerId) : 0,
                locationId: globalData.LocationId ? parseInt(globalData.LocationId) : 0,
                isGuest : headercurrentuser?.isGuestUser
            },
            parts: parts
        };

        partsService.addPartNumber(model)
            .then((response: any) => {
                setIsAddingParts(false)
                if (response.isSuccessful) {
                    props?.getMiningParts();
                    helperfunctions.showSuccessMessage(response?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Add_Part_Success_Msg));
                    props.uploadOnClick();
                    props.onRefresh(null, true);
                }
                else
                    helperfunctions.showErrorMessage(response?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Add_Part_Error_Msg));
            })
            .catch((e: any) => {
                setIsAddingParts(false)
                helperfunctions.showErrorMessage(e);
            });
    }

    const addPartNumberGrid = () => {
        if (partData?.length > 0) {
            const partsModel = Object.values(partData.reduce((accumulator, part) => {
                const partNumber = part.partNumber;
                const qty = part.qty;
                if (accumulator.hasOwnProperty(partNumber)) {
                    accumulator[partNumber].quantity += qty;
                } else {
                    accumulator[partNumber] = {
                        manufacturer: { code: "", name: part.manufacturer ?? "" },
                        partNumber: partNumber,
                        quantity: qty,
                        machine: { mDbId: 0 }
                    };
                }
                return accumulator;
            }, {}));
            let isPartNoNotValid = partsModel?.filter((s: any) => s.partNumber == null || s.partNumber == "" || s.partNumber?.toLowerCase() == "select")?.length > 0;
            let isQuantityNotValid = partsModel?.filter((s: any) => s.qty < 0 || s.qty > 9999)?.length > 0;
            let isManufactureNotValid = partsModel?.filter((s: any) => (s.manufacturer?.name ?? "") == "")?.length > 0;

            if (isPartNoNotValid) {
                helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Part_Number_Required));
            }
            else if (isManufactureNotValid) {
                helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Manufacture_Required));
            }
            else if (isQuantityNotValid) {
                helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Quantity_Validation));
            }
            else {
                addPartNumber(partsModel);
            }
        }
    }

    const columns = [

        {
            field: "partNumber",
            title: t(RESOURCE.MyK_Grid_Part_Number),
            columnMenu: 'ColumnMenu',
            sortable: true,
            width: 280,
            editable: true,
            cell: partNumberCell
        },
        {
            field: 'qty',
            title: t(RESOURCE.MyK_Label_ShoppingCart_Quantity),
            columnMenu: 'ColumnMenu',
            style: { textAlign: 'center' },
            sortable: true,
            width: 120,
            editable: true,
            cell: quantityCell
        },
        {
            field: 'manufacturer',
            title: t(RESOURCE.MyK_Grid_Manufacturer),
            columnMenu: 'ColumnMenu',
            sortable: true,
            width: 240,
            editable: true,
            cell: manufactuerCell
        },
        {
            field: 'source',
            title: t(RESOURCE.MyK_Grid_Source),
            columnMenu: 'ColumnMenu',
            sortable: true,
            width: 200,
            editable: false
        },
        {
            field: 'Action',
            title: '',
            columnMenu: 'ColumnMenu',
            sortable: false,
            cell: (row: any) => <Action row={row} />,
            width: 220
        },
    ]

    const setResponseData = (data: any, uid: any) => {
        let result = data?.filter((t: any) => ((t?.partNumber ?? "").trim() != "")).map(
            (t: any) => {
                t.partNumber = t?.partNumber.trim();
                t.manufacturer = ((t?.manufacturer ?? "").trim() != "") ? t?.manufacturer.trim() : "Komatsu";
                t.fileUid = uid;
                return t;
            })
        setPartData((prev: any) => {
            return prev.concat(result)
        })
    }

    const onSaveRequest = ((files: UploadFileInfo[], _: any, onProgress: any) => {
        const uid = files[0].uid;
        setFiles((prev: any) => [...prev, files]);
        progressRef.current[uid] = 0;
        const saveRequestPromise = new Promise<{ uid: string }>((resolve, reject) => {
            partsService.uploadParts(files).then((response: any) => {
                if (response?.find((t: any) => t.status?.toLowerCase() == "failed")) {
                    setInvalidFile((prev: any) => [...prev, files[0].name]);
                    setInvalidFileResponse((prev: any) => [...prev, response?.[0]]);
                    onProgress(uid, {
                        loaded: 100,
                        total: 100,
                    } as ProgressEvent);
                    resolve({ uid: uid });
                    delete progressRef.current[uid];
                    clearInterval(requestIntervalRef.current[uid]);
                }
                else {
                    if (response.length > 0) {
                        setResponseData(response, uid);
                    }
                    onProgress(uid, {
                        loaded: 100,
                        total: 100,
                    } as ProgressEvent);
                    resolve({ uid: uid });
                    delete progressRef.current[uid];
                    clearInterval(requestIntervalRef.current[uid]);
                }
            });
        });

        return saveRequestPromise;
    });

    const onRemoveRequest = (files: UploadFileInfo[], _: any) => {
        const uid = files[0].uid;
        const removedFileName = files?.[0]?.uid ?? "";
        const filteredData = partData?.length > 0 ? partData.filter((item: any) => item?.fileUid !== removedFileName) : [];
        setPartData(filteredData);
        const removeRequestPromise = new Promise<{ uid: string }>((resolve) => {
            resolve({ uid: uid });
            setInvalidFile([]);
            setInvalidFileResponse([]);
        });

        return removeRequestPromise;
    };

    const onAddFiles = (event: any) => {
        const newFiles = event?.affectedFiles ?? [];
        const isAtLeastOneFileInvalid = newFiles.some((inputFile: any) => {
            const validFileTypes = [`.${UPLOADFILETYPE[UPLOADFILETYPE.CSV].toLowerCase()}`, `.${UPLOADFILETYPE[UPLOADFILETYPE.TXT].toLowerCase()}`]
            const isAllowedExtension = validFileTypes.includes(inputFile.extension.toLowerCase());
            return !isAllowedExtension;
        });

        if (isAtLeastOneFileInvalid) {
            const newArray = event.target.state.files.slice(0, -newFiles?.length);
            event.target.state.files = newArray;
            const confimObject = {
                title: t(RESOURCE.MyK_Label_SC_Warning),
                message: t(RESOURCE.MyK_Label_SC_Upload_Extension_Warning),
                confirmmessage: '',
                buttonLabel: {
                    yes: t(RESOURCE.MyK_Label_OK)
                },
                yesOnclick: () => {
                },
                hideNoButton: true
            }
            confirmDailog(confimObject);
        }
        setFilteredFiles(event.target.state.files);

    }

    const hasFailedStatus = invalidFileResponse?.length ? invalidFileResponse.some((item : any)=> item.statusCode == 3) : false;

    return (
        <div className='uploadpartlist'>
            {isAddingParts && <Loader/>}
            <div>
                <a className="partsorder_label" onClick={partsinfoOnclick} onKeyDown={() => { }} title={t(RESOURCE.MyK_Label_ShoppingCart_Shared_Parts_Order_Files_Upload)} >{t(RESOURCE.MyK_Label_ShoppingCart_Shared_Parts_Order_Files_Upload)}<span className="fa fa-info-circle ml-1"></span></a>
            </div>
            {ispartsinfo ?
                <div className='row mt-2'>
                    <div className='col-12'>
                        <div className='noteBox'>
                            <p className="uploadpartlistnoteInfoBox ">
                                <div className="col-sm-12">
                                    <h4 className="bold-custom">{t(RESOURCE.MyK_Label_SC_UP_CSV)}</h4>
                                    <p>
                                        {t(RESOURCE.MyK_Label_SC_UP_Info1_1)}
                                    </p>
                                    <p>{t(RESOURCE.MyK_Label_SC_Up_Info2_2_New)}</p>
                                    <p>
                                    </p><div className="alertinfobox in col-lg-12">
                                        <ul className="list-unstyled">
                                            <li className="bold-custom">{t(RESOURCE.MyK_Label_SC_UP_Info_eg)}:&nbsp;</li>
                                            <li>{t(RESOURCE.MyK_Label_SC_UP_Info_Mc1)}</li>
                                            <li>{t(RESOURCE.MyK_Label_SC_UP_Info_Mc2)}</li>
                                            <li>{t(RESOURCE.MyK_Label_SC_Up_Info_Mc3)}</li>
                                        </ul>
                                        <small className="bold-custom">{t(RESOURCE.MyK_Label_SC_Up_Info1_3)}</small>
                                    </div>
                                    <p></p>
                                </div>
                                <div className="col-sm-12">
                                    <h4 className="bold-custom">
                                        {t(RESOURCE.MyK_Label_SC_Up_Info2)}
                                    </h4>
                                    <p>{t(RESOURCE.MyK_Label_SC_Up_Info2_1)}</p>
                                </div>
                                <div className="col-sm-12">
                                    <h4 className="bold-custom">
                                        {t(RESOURCE.MyK_Label_SC_Up_Info2_11)}
                                    </h4>
                                    <p>{t(RESOURCE.MyK_Label_SC_Up_Info2_111)}</p>
                                    <p>{t(RESOURCE.MyK_Label_SC_Up_Info2_112)}</p>
                                    <h4 className="bold-custom">{t(RESOURCE.MyK_Label_SC_UP_Info2_2)}</h4>
                                    <p>{t(RESOURCE.MyK_Label_SC_Up_Info2_21)}</p>
                                    <p>{t(RESOURCE.MyK_Label_SC_Up_Info2_22)}</p>
                                    <p>{t(RESOURCE.MyK_Label_SC_Up_Info2_23)}</p>
                                    <p>{t(RESOURCE.MyK_Label_SC_Up_Info2_24)}</p>
                                    <p>{t(RESOURCE.MyK_Label_SC_Up_Info2_25)}</p>
                                </div>
                            </p>
                        </div>
                    </div>
                </div> : null
            }
            <div className="row mt-4 partsListUpload" >
                <div className="col-sm-6 col-12">
                    <div className="mt-2" >
                        <span className="fileuploadtxt"><span className="fa fa-info-circle mr-1"></span>{t(RESOURCE.MyK_Label_ShoppingCart_Select_File_To_Upload)}</span>
                        <LocalizationProvider language="myUploadCustomMessages">
                            <Upload
                                multiple={true}
                                defaultFiles={[]}
                                autoUpload={false}
                                batch={false}
                                saveUrl={onSaveRequest}
                                removeUrl={onRemoveRequest}
                                showActionButtons
                                restrictions={{
                                    allowedExtensions: ['.csv', '.txt']
                                }}
                                    ref={uploadRef}
                                className={'uploadFileView uploadFileViewCustom'}
                                actionsLayout={'start'}
                                files={filteredFiles}
                                onAdd={onAddFiles}
                                
                            />
                        </LocalizationProvider>
                        <span className="uploadmultipletxt">{t(RESOURCE.MyK_Label_ShoppingCart_Multiple_File_Upload)}</span>
                    </div>
                </div>
                <div className="col-sm-6 col-12">
                    <button className="downloadtemplate mt-2" onClick={downloadTemplate}><span className="fa fa-download mr-1"></span>{t(RESOURCE.MyK_HealthLabel_CPT_Download_Template)}</button>
                    {invalidFile?.length > 0 && <div className="invalidfile-error mt-2">
                        <label>{invalidFile?.join(", ")} </label>
                        &nbsp;{hasFailedStatus ? t(RESOURCE.MyK_Label_SC_File_Invalid_PartNumber) : t(RESOURCE.MyK_Label_SC_File_Invalid_Format)}
                    </div>}
                </div>
            </div>
            {files?.length > 0 &&
                <>
                    <div className='row mt-3'>
                        <div className='col-12'>
                            <div className="bookmarked_header clearfix px-2">
                                <span className="subHeading">{t(RESOURCE.Myk_Label_PartsUpload)}</span>
                                <button className={`clearbtn ml-2 ${partData?.length <= 0 ? "disabled" : ""}`} disabled={partData?.length <= 0} onClick={() => clearAll()} title={t(RESOURCE.MyK_Label_SC_Up_Clear)}>{t(RESOURCE.MyK_Label_SC_Up_Clear)}</button>
                                <button className={`addtocartbtn ${partData?.length <= 0 ? "disabled" : ""}`} disabled={partData?.length <= 0} onClick={() => addPartNumberGrid()} title={t(RESOURCE.MyK_Label_AddToCart)}>{t(RESOURCE.MyK_Label_AddToCart)}</button>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12 uploadPartListTable'>
                        <DataTable
                                defaultPageSize={100}
                                data={partData}
                                dataColumn={columns}
                                onItemChange={onItemChange}
                                dataItemKey="id"
                                className='uploadPartListTable'
                            />
                        </div>
                    </div>
                </>}
            <div className="uploadpopup_footer mt-3 mb-2">
                <button className="cancelbtn" onClick={props.uploadOnClick}><span className="fa fa-times mr-1" title={t(RESOURCE.MyK_Label_Cancel)}></span>{t(RESOURCE.MyK_Label_Cancel)}</button>
            </div>
        </div>
    );
}

export default UploadPartsList;